import {app} from "@/main";

export function activateEntityFromList(entities, entityIdentifier) {
    if (!entities || !entities.length) return undefined;

    if (!entityIdentifier) return entities[0];

    let result = entities.find((entity) => entity.identifier == entityIdentifier);

    if (result) return result;

    return entities[0];
}

export function convertAsKeywords(text) {
    return [...new Set(text.split(" "))];
}

export function findObjectInArrayByPropertyValue(arr, property, propertyValue) {
    let obj = arr.find((obj) => obj[property] === propertyValue); // MUST exist
    if (!obj) return undefined;
    return obj;
}

export function findObjectIndexInArrayByPropertyValue(
    arr,
    property,
    propertyValue
) {
    let idx = arr.findIndex((obj) => obj[property] === propertyValue); // MUST exist
    if (idx < 0) return undefined;
    return idx;
}

export function formatFrenchAddress(street, postcode, city) {
    street = street ? street.trim() : "";
    postcode = postcode ? postcode.trim() : "";
    city = city ? city.trim() : "";

    var address = street ? street + "\n" : "";
    var suffix = [postcode, city].join(' ').trim();
    return address + suffix
}

export function getAbsoluteHeight(el) {
    // Get the DOM Node if you pass in a string
    el = typeof el === "string" ? document.querySelector(el) : el;

    var styles = window.getComputedStyle(el);
    var margin =
        parseFloat(styles["marginTop"]) + parseFloat(styles["marginBottom"]);

    return Math.ceil(el.offsetHeight + margin);
}

export const getUniqueId = () => {
    return Math.random().toString(36).slice(2, 10);
};

export function hasEnrichedSlot(component, slotName) {
    return !!component.$slots[slotName];
}

export class NumberFormatter {
    static toLocalString(number, locale) {
        return number.toLocaleString(locale);
    }

    static toSI(num, digits) {
        var si = [
            {value: 1, symbol: ""},
            {value: 1e3, symbol: "k"},
            {value: 1e6, symbol: "M"},
            {value: 1e9, symbol: "G"},
            {value: 1e12, symbol: "T"},
            {value: 1e15, symbol: "P"},
            {value: 1e18, symbol: "E"},
        ];
        var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
        var i;
        for (i = si.length - 1; i > 0; i--) {
            if (num >= si[i].value) {
                break;
            }
        }
        return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
    }
}

export function openToast(title, message, isError = false) {
    app.$bvToast.toast(message, {
        // noAutoHide: true,
        solid: true,
        title: title,
        toaster: "b-toaster-bottom-left",
        variant: isError ? "danger" : "info",
        appendToast: true,
    });
}

export function getCanvasContentAsPngBase64(canvas) {
    return canvas.toDataURL("image/png").split(';base64,')[1]
}


export function base64toBlob(base64Data, contentType) {
    // From https://gist.github.com/Marceloalves6/d1f590437f7fe45ac6832e5177c84be6
    contentType = contentType || '';
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        const begin = sliceIndex * sliceSize;
        const end = Math.min(begin + sliceSize, bytesLength);

        const bytes = new Array(end - begin);
        for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, {type: contentType});
}